import type { RefObject } from 'react';

const NAVBAR_MOBILE_PLACEHOLDER_HEIGHT = 48;

export const scrollIntoView = (element: RefObject<HTMLDivElement>, isDesktop: boolean, scrollTopMargin = 0) => {
  const pdpPageContainer = document.getElementById('pdp-page-container');
  const productContainerDesktop = document.getElementById('pdp-container-desktop');
  const stickyContainer = document.getElementById('pdp-sticky-container');
  const stickyHeader = document.getElementById('nav-bar-sticky-wrapper');

  const productContainerHeight = productContainerDesktop?.getBoundingClientRect().height || 0;
  const contentOffset = pdpPageContainer?.offsetTop || 0;
  const stickyContainerHeight = stickyContainer?.getBoundingClientRect().height || 0;
  const elementContainerTop = element.current?.offsetTop || 0;
  const stickyHeaderHeight = stickyHeader?.getBoundingClientRect().height || 0;
  const hasStickyHeader = stickyHeader?.classList.contains('sticky');
  const elementTop = element.current?.getBoundingClientRect().top || 0;

  const scrollPosition =
    contentOffset +
    (productContainerHeight - stickyContainerHeight) +
    elementContainerTop +
    scrollTopMargin -
    (elementTop < 0 ? stickyHeaderHeight : 0);

  const mobileScrollPosition =
    contentOffset +
    (productContainerHeight - stickyContainerHeight) +
    elementContainerTop +
    scrollTopMargin -
    (elementTop < 0 || !hasStickyHeader ? stickyHeaderHeight : 0) +
    (!hasStickyHeader ? NAVBAR_MOBILE_PLACEHOLDER_HEIGHT : 0);

  window.scrollTo({
    top: isDesktop ? scrollPosition : mobileScrollPosition,
    behavior: 'smooth',
  });
};
